import FileModule from './FileContainer';
import FileMobileModule from './FileContainer.mobile';
import {isMobile} from 'Utils/device';
import './file.scss'

let FileModuleFn = (isMobile)? FileMobileModule: FileModule;

export default FileModuleFn;